// lib/settings.ts — клиентские константы студии (этап 6.5, Config pass).
// Всё, что раньше было магическими числами в компонентах, живёт здесь
// и переопределяется через VITE_*-переменные при сборке админки.
// import.meta.env — определён Vite'ом; в tsx-тестах (и любом не-Vite окружении) undefined.
// Читаем через безопасный fallback, чтобы модуль импортировался и в тестах.
const env: Record<string, string | undefined> =
  (import.meta as { env?: Record<string, string | undefined> }).env ?? {};

export const settings = {
  // тосты (авто-dismiss)
  toastInfoMs: Number(env.VITE_TOAST_INFO_MS ?? 3500),
  toastErrorMs: Number(env.VITE_TOAST_ERROR_MS ?? 6000),
  // превью-вьюпорты (browser width)
  viewportTablet: env.VITE_PREVIEW_TABLET_WIDTH ?? '768px',
  viewportMobile: env.VITE_PREVIEW_MOBILE_WIDTH ?? '390px',
  // медиа: размер тамбнейла превью (должен входить в MEDIA_SIZES) + лимит загрузки
  mediaThumbSize: Number(env.VITE_MEDIA_THUMB_SIZE ?? 640),
  maxUploadBytes: Number(env.VITE_MAX_UPLOAD_BYTES ?? 10 * 1024 * 1024),
  // fallback-значения (когда сайт ещё не загружен)
  defaultSiteUrl: env.VITE_DEFAULT_SITE_URL ?? 'https://example.ru',
  defaultTenantSlug: env.VITE_DEFAULT_TENANT_SLUG ?? 'demo',
  // Публичный адрес сайта (CP0.2/CP1.1): dev — vite-прокси /s; prod — VITE_SITE_BASE_URL
  // (например, https://{project}.mcpsite.ru — {project} подставляется автоматически).
  siteBaseUrl: env.VITE_SITE_BASE_URL ?? '',
};

/** Человекочитаемый размер лимита (для подсказок): «10 МБ». */
export function formatBytes(n: number): string {
  if (n >= 1024 * 1024) return `${Math.round(n / (1024 * 1024))} МБ`;
  if (n >= 1024) return `${Math.round(n / 1024)} КБ`;
  return `${n} Б`;
}
